/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue'
import vuexI18n from 'vuex-i18n'
import store from '@/store'
import variables from '@/utils/variables'

// Language imports
import en from '@/i18n/en'
import nl from '@/i18n/nl'
import fr from '@/i18n/fr'

Vue.use(vuexI18n.plugin, store, {
  moduleName: 'i18n',
  onTranslationNotFound (locale, key) {
    // console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`)
  }
})

// add translations directly to the application
Vue.i18n.add('en', en)
Vue.i18n.add('nl', nl)
Vue.i18n.add('fr', fr)

// set the start locale to use, fetched from employee data
// default to english
Vue.i18n.set(variables.defaultLocale)



// WEBPACK FOOTER //
// ./src/i18n.js